/**
 * Handle a 402 `pro_access_required` error from a guarded backend endpoint
 * (e.g. request-negotiation-action). The spec (monetization_overview.md §2.12)
 * treats this as a race-window signal between frontend gating and backend
 * enforcement: when it fires, the user should see the upgrade modal rather
 * than a raw error toast.
 *
 * @param {Error & { status?: number, code?: string | null }} err
 * @param {(args: { source: string }) => void} triggerUpgradeModal
 * @param {string} source - PostHog-style source tag for the upgrade modal
 * @returns {boolean} true if the error was handled; false otherwise (caller should rethrow / surface)
 */
export function handleProAccessError(err, triggerUpgradeModal, source) {
  if (err?.status === 402 && err?.code === 'pro_access_required') {
    triggerUpgradeModal?.({ source });
    return true;
  }
  return false;
}
